<template>
<section
  v-if="variants.v1 === variant"
  class="n-section-primary"
  :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? vars.textColor : 'var(--c-text-primary)'}`"
>
  <div class="tw-relative tw-flex tw-h-full tw-w-full tw-flex-col tw-gap-6 content-container">

    <div
      v-if="vars.titleHtml"
      class="tw-mb-2 tw-grid tw-grid-cols-1 xl:tw-grid-cols-12 xl:tw-gap-20"
    >
      <div class="hidden xl:tw-block xl:tw-col-span-5"></div>
    </div>

    <!-- 2) SLIDER (sadece foto + card title + description + oklar) -->
    <MotionGroup :preset="vars.animationText ? vars.animationText : 'fadeVisible'" :duration="600" is="div">
      <Swiper
        :modules="[SwiperPagination]"
        :pagination="false"
        :slides-per-view="1"
        :space-between="20"
        effect="fade"
        :clickable="true"
        :breakpoints="{ 320:{slidesPerView:1}, 640:{slidesPerView:1}, 1024:{slidesPerView:1} }"
        :auto-height="true"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        class="tw-w-full"
      >
      
        <SwiperSlide v-for="(card, index) in cards" :key="`cards-slide-${index}`">
          
          <div class="tw-grid tw-grid-cols-1 tw-gap-6 tw-items-start xl:tw-grid-cols-12 xl:tw-gap-20">
            <!-- Sol: Fotoğraf -->
            <div class="xl:tw-col-span-5" :class="{ 'xl:tw-order-last': vars.isReversedBool }">
              <library-image
                v-if="card.photo"
                :src="card.photo"
                :alt="card.title || ''"
                class="tw-w-full tw-object-cover tw-aspect-[4/3]"
                :style="`border-radius: var(--c-rounded);`"
              />
            </div>

            <!-- Sağ: Card Title + Description + Pagination -->
            <div class="xl:tw-col-span-7 tw-flex tw-flex-col tw-gap-4">
              <div v-html="vars.titleHtml" class="tw-leading-tight"></div>
       
              <h4>{{ card.title }}</h4>
              
              <!-- Mobil responsive description -->
              <p class="tw-text-[var(--c-text-primary)] tw-min-h-[120px] md:tw-min-h-[100px] xl:tw-h-[220px] tw-overflow-hidden tw-leading-relaxed">
                {{ card.description }}
              </p>

           
              <div class=" tw-mb-4 md:tw-mb-2 tw-flex tw-items-center tw-gap-6 tw-justify-start">
                <LibrarySliderPagination
                  :swiper="swiper"
                  :can-paginate-back="canPaginateBack"
                  :can-paginate-next="canPaginateNext"
                  variant="v14"
                />
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </MotionGroup>
  </div>
</section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin'

// Swiper Vue
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Pagination as SwiperPagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'

export default defineNuxtComponent({
  mixins: [ComponentMixin],
  components: { Swiper, SwiperSlide },

  data() {
    return {
      variants: { v1: 'v1', v2: 'v2' },
      swiper: null as any,
      canPaginateBack: null as boolean | null,
      canPaginateNext: null as boolean | null,
      
      SwiperPagination,
    }
  },

  computed: {
 
    cards() {
      return this.groupedVariables?.cards || []
    },
  },

  methods: {
    onSwiper(swiper: any) {
      this.swiper = swiper
      this.onSlideChange()
    },
    onSlideChange() {
      if (!this.swiper) return
      this.canPaginateBack = !this.swiper.isBeginning
      this.canPaginateNext  = !this.swiper.isEnd
    },
  },

  mounted() {
    this.onSlideChange()
  },
})
</script>

<style scoped>
.v11 {
    display: flex;
    justify-content: start !important;
    align-items: start !important;
    gap: 20px;
}


@media (max-width: 768px) {
  .swiper-slide {
    min-height: auto;
    overflow: visible;
  }
}
</style>